import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './upload-image-button.scss';
import { handleEnterKeyUp } from '../../services/accessibility';

class UploadImageButton extends Component {
  triggerInputClick = () => {
    this.input && this.input.click();
  };

  setInput = input => {
    this.input = input;
  };

  handleChange = event => {
    if (event.target.files.length) {
      this.props.onChange(event.target.files[0]);
    }
  };

  render() {
    const { className, onClick: handleClick } = this.props;

    return (
      <div
        onClick={handleClick}
        onKeyUp={handleEnterKeyUp(this.triggerInputClick)}
        tabIndex="0"
        className={classNames(styles.button, className, 'upload-image-button')}
      >
        <span className={styles.icon}/>
        <input
          ref={this.setInput}
          className={styles.file}
          type="file"
          accept="image/*"
          onChange={this.handleChange}
          tabIndex="-1"
        />
      </div>
    );
  }
}

UploadImageButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default UploadImageButton;



// WEBPACK FOOTER //
// ./app/components/upload-image-button/upload-image-button.js